import { render } from "./ImageWithFallback.vue?vue&type=template&id=4259ccc3&scoped=true"
import script from "./ImageWithFallback.vue?vue&type=script&lang=ts"
export * from "./ImageWithFallback.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-4259ccc3"

export default script